"use strict";
/*
 
 */
class InputChoice {
    constructor(selector) {
        this.initClassName = "-isInit";
        this.className = "-active";
        if (!$(selector).hasClass(this.initClassName)) {
            this.init(selector);
        }
    }
    init(selector) {
        this.selector = $(selector).attr("for");
        this.DOM = {
            $input: $('[name="' + this.selector + '"'),
        };
        this.DOM.$input.addClass(this.initClassName);
        this.addEvents();
        this.changeInput(this.DOM.$input);
    }
    changeInput($input) {
        let value = null;
        switch ($input.get(0).type) {
            case "select-one":
                value = $input.find(':selected').attr('data-change');
                break;
            case "radio":
                value = $input.filter(':checked').attr('data-change');
                break;
            default:
                value = $input.data("change");
        }
        if (this.DOM.$target) {
            this.DOM.$target.removeClass(this.className);
            this.DOM.$target = null;
        }
        if (value) {
            let $target = $('[data-wrapper="' + value + '"');
            if ($target.get(0)) {
                $target.addClass(this.className);
                this.DOM.$target = $target;
            }
        }
    }
    addEvents() {
        this.DOM.$input.change((e) => {
            let $input = $(e.currentTarget);
            this.changeInput($input);
        });
    }
}
;
//# sourceMappingURL=maty.inputChoice.js.map